$(function () {
    if(!document.querySelector('#regist-completion-dialog')){
        return;
    }
    var registEasyCompletionDialog = {
        dialogBoxDom: document.querySelector('#regist-completion-dialog'),
        maskDom: document.querySelector('#regist-completion-dialog').querySelector('.mask'),
        dialogDom: document.querySelector('#regist-completion-dialog').querySelector('.login-container'),
        vueObject: null,

        vueExp: function () {
            var dialogObj = this;
            this.vueObject = new Vue({
                    el: "#vue-regist-completion-dialog",
                    data: {
                        // 更新表单
                        registForm: {
                            title: '完善企业认证即可抽奖',
                            //姓名 邮箱 单位名称
                            formList: {
                                name: {
                                    lebal: '姓　　名',
                                    placeholder: '请输入您的姓名',
                                    value: '',
                                    type: 'text',
                                    isShowError: false,
                                    isRequired: true,
                                    reg: '',
                                    errorText: '',
                                    errorTextContent: '请输入您的姓名',
                                    errorTextEmpty: '请输入您的姓名',
                                    focusAction: function () {
                                        // gioTrackAction.gio_base('individualRegister_addTol');
                                    }
                                },
                                email: {
                                    lebal: '邮　　箱',
                                    placeholder: '请输入您的邮箱',
                                    value: '',
                                    type: 'text',
                                    isShowError: false,
                                    isRequired: true,
                                    reg: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
                                    errorText: '',
                                    errorTextContent: '你输入的邮箱不正确',
                                    errorTextEmpty: '请输入您的邮箱',
                                    focusAction: function () {
                                        // gioTrackAction.gio_base('individualRegister_addCode');
                                    }
                                },
                                enterpriseName: {
                                    lebal: '单位名称',
                                    placeholder: '请输入您的单位名称',
                                    value: '',
                                    type: 'text',
                                    isShowError: false,
                                    isRequired: true,
                                    reg: '',
                                    errorText: '',
                                    errorTextContent: '请输入您的单位名称',
                                    errorTextEmpty: '请输入您的单位名称',
                                    focusAction: function () {
                                        // gioTrackAction.gio_base('individualRegister_addCode');
                                    }
                                },
                            },
                            subBtnText: '完成认证去抽奖',
                            subBtnDisabled: false,
                            isShowTextBtn: true,
                            textBtnText: '下次再说'
                        },
                        form: {
                            title: ''
                        },
                        list: [],
                        keyword: '',
                        userInfo: {},
                        loginTimeout: null
                    },
                    created: function () {
                        this.form = this.registForm;
                        this.setUserinfo();
                    },
                    methods: {

                        // 回填用户信息
                        setUserinfo: function () {
                            this.registForm.formList.name.value = getUserInfo.options.name;
                            this.registForm.formList.email.value = getUserInfo.options.email;
                            this.registForm.formList.enterpriseName.value = getUserInfo.options.enterpriseName;
                        },

                        // 取消
                        cancel: function () {
                            solution_msg.dialog('完成企业认证即可抽奖! 确定放弃吗？', function () {
                                dialogObj.hideDialog();
                            })
                        },

                        // 更新用户信息
                        update: function () {
                            var _this = this;
                            if (!this.verifyForm() || this.registForm.subBtnDisabled) {
                                console.log('验证不通过');
                                return;
                            }

                            // 组装信息
                            var updateUserInfo = [{
                                "fieldName": "name",
                                "value": this.registForm.formList.name.value
                            }, {
                                "fieldName": "email",
                                "value": this.registForm.formList.email.value
                            }, {
                                "fieldName": "enterprise_name",
                                "value": this.registForm.formList.enterpriseName.value
                            }];

                            // 更新用户信息
                            this.registForm.subBtnDisabled = true;

                            userCommonAPI.updateUserInfo(updateUserInfo, function (res) {
                                if(res.errCode === 0){
                                    userRecord({behaviorType: '轻注册完善信息', behaviorResult: '轻注册完善信息成功'});
                                    gioTrackAction.gio_base('individualRegisterSuccess01');
                                    _this.registForm.subBtnDisabled = false;
                                    dialogObj.hideDialog();
                                    window.cateData.needCompletionInfo = 0;
                                    if(cateData.device === 'pc'){
                                        window.open(window.cateData.linghtRegLuckyLink);
                                        window.location.reload();
                                    }else{
                                        window.location.href = window.cateData.linghtRegLuckyLink;
                                    }
                                }else{
                                    userRecord({behaviorType: '轻注册完善信息', behaviorResult: '轻注册完善信息失败'});
                                    _this.registForm.subBtnDisabled = false;
                                    solution_msg.alert(res.msg);
                                }
                            });
                        },

                        // 验证程序
                        verify: function (itemObj) {
                            var flag = true;
                            if (itemObj.isRequired && itemObj.value === '') {
                                itemObj.isShowError = true;
                                itemObj.errorText = itemObj.errorTextEmpty ? itemObj.errorTextEmpty : '请输入' + itemObj.lebal;
                                flag = false;
                                return flag;
                            }
                            if (itemObj.reg && itemObj.value) {
                                itemObj.isShowError = !itemObj.reg.test(itemObj.value);
                                if (itemObj.isShowError) {
                                    itemObj.isShowError = true;
                                    itemObj.errorText = itemObj.errorTextContent ? itemObj.errorTextContent : '您输入的' + itemObj.lebal + '错误';
                                    flag = false;
                                }
                            }
                            if (flag) {
                                itemObj.isShowError = false;
                                itemObj.errorText = '';
                            }
                            return flag;
                        },

                        //验证表单
                        verifyForm: function () {
                            var flag = true;
                            for (var item in this.form.formList) {
                                var itemObj = this.form.formList[item];
                                if(this.verify(itemObj) === false){
                                    flag = false;
                                }
                            }
                            return flag;
                        },
                        // 登录弹框内的关闭按钮
                        close: function () {
                            dialogObj.hideDialog();
                        },

                    },
                    watch: {}
                }
            )
        },
        showDialog: function () {
            if (!this.vueObject) {
                this.vueExp();
            }
            this.dialogBoxDom.style.display = 'block';
            this.maskDom.classList.remove('dialog-mask-ani-fade-out');
            this.maskDom.classList.add('dialog-mask-ani-fade-in');

            this.dialogDom = document.querySelector('#regist-completion-dialog').querySelector('.login-container');
            this.dialogDom.classList.remove('tr-dialog-ani-to-top');
            this.dialogDom.classList.add('tr-dialog-ani-from-top');

            /*gioTrackAction.gio_base('individualRegisterClick',{
                'individualRegisterEntrancePageTitle': document.title,
                'individualRegisterEntrancePageURL': window.location.href
            })*/
            //禁止后方滚动
            common.setScroll.unScroll();
        },
        hideDialog: function () {
            this.maskDom.classList.remove('dialog-mask-ani-fade-in');
            this.maskDom.classList.add('dialog-mask-ani-fade-out');

            this.dialogDom.classList.remove('tr-dialog-ani-from-top');
            this.dialogDom.classList.add('tr-dialog-ani-to-top');

            var _this = this;
            setTimeout(function () {
                _this.dialogBoxDom.style.display = 'none';
            }, 200);

            //允许后方滚动
            common.setScroll.removeUnScroll();

        },
        showLoading: function () {
            document.querySelector('.login-dialog-loading').style.display = 'block';
            //禁止后方滚动
            common.setScroll.unScroll();
        },
        hideLoading: function () {
            document.querySelector('.login-dialog-loading').style.display = 'none';
            //允许后方滚动
            common.setScroll.removeUnScroll();
        },

        init: function () {
        }
    };
    window.registEasyCompletionDialog = registEasyCompletionDialog;
});


